export default __webpack_public_path__ + "static/Disclaimer-ff599a4899ceaaeee466311846550349.png";